import React from 'react';
import { Stack, TextField } from '@mui/material';
import { signatoryProps } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/type/preview.type';
import MuiButton from 'components/__v5__/Button/MuiButton';
import SignatureField from '../SignatureField/SignatureField';

interface MultipleSignatureFieldProps {
  signatory?: signatoryProps;
  removeSignature: (id: string) => void;
  toggleSignaturePad: () => void;
  attachmentLoading: boolean;
  isTable?: boolean;
}

export const MultipleSignatureField: React.FC<MultipleSignatureFieldProps> = ({
  signatory,
  removeSignature,
  toggleSignaturePad,
  attachmentLoading,
  isTable = false,
}) => (
  <Stack
    border="1px solid"
    borderColor="divider"
    direction={!isTable ? 'row' : 'column'}
    spacing={1}
    mt={1.5}
    mb={1.5}
    p={1}
  >
    <Stack width={!isTable ? '500px' : '100%'}>
      <SignatureField
        savedSignature={signatory?.file}
        removeSignature={() => signatory && removeSignature(signatory.id)}
        toggleSignaturePad={toggleSignaturePad}
        isLoading={attachmentLoading}
        created_at={signatory?.created_at}
      />
    </Stack>

    <Stack alignSelf="center" spacing={1}>
      <TextField
        placeholder="Signatory Name"
        variant="outlined"
        value={signatory?.signatory_name || signatory?.name}
        disabled
      />

      <MuiButton
        variant="text"
        color="primary"
        onClick={() => signatory && removeSignature(signatory.id)}
      >
        Remove Signature
      </MuiButton>
    </Stack>
  </Stack>
);
